import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import useAppNavigation from "./useAppNavigation";

// --- Real mobile screens that compile and render today ---
import Login from "../Screens/Login/Login";
import Registration from "../Screens/Login/Registration";
import ForgotPassword from "../Screens/Login/ForgotPassword";
import DemoAccount from "../Screens/Login/DemoAccount";
import DrawerScreen from "../Screens/Drawer/DrawerScreen";
import DashboardBottom from "../Screens/BottomTab/DashboardBootom";
import Vehicles from "../Screens/MasterData/Vehicle";
import Vacation from "../Screens/MasterData/Vacation/Vacation";
import MainPointofInterest from "../Screens/MasterData/PointofInterest/MainPointofInterest";
import Holidays from "../Screens/MasterData/Holiday/Holidays";
import GeofenceArea from "../Screens/MasterData/Geofence/GeofenceArea";
import ParkStation from "../Screens/MasterData/ParkingStation/ParkStation";
import UsersAdministartion from "../Screens/Users/UsersAdministartion";
import Drivers from "../Screens/Drivers/Drivers";
import FleetManager from "../Screens/FleetManager/FleetManager";
import UserInsightDaily from "../Screens/MasterData/UserDashboard/UserInsightDaily";
import TransportManager from "../Screens/TransportManager/TransportManager";
import Delivery from "../Screens/Delivery Person/Delivery";
import VehicleAssistant from "../Screens/VehicleAssistants/VehicleAssistant";
import PaymentInvoice from "../Screens/MasterData/Payment/PaymentInvoice";
import PaidInvoice from "../Screens/MasterData/Payment/PaidInvoice";
import MainParkingManagement from "../Screens/MasterData/ParkingManagement/MainParkingManagement";
import DispatchCustomer from "../Screens/DispatchManagement/DispatchCustomer";
import DispatchDashboard from "../Screens/DispatchManagement/DispatchDashboard";
import Orders from "../Screens/DispatchManagement/Orders";
import Merchant from "../Screens/DispatchManagement/Merchant";
import DispatchCustomerViewDetails from "../Screens/DispatchManagement/DispatchCustomerViewDetails";
import VehicleExpenseOp from "../Screens/VehicleExpense/ VehicleExpenseOp";
import VehicleSpare from "../Screens/VehicleSparePart/VehicleSpare";
import FleetMainTab from "../Screens/FleetVehicle/FleetMainTab";
import VehicleAccessory from "../Screens/VehicleAccess/VehicleAccessory";
import VehicleFine1 from "../Screens/VehileFine/VehicleFine1";
import FuelExpenses from "../Screens/FuelExpense/FuelExpenses";
import VehicleInspectionDashboard from "../Screens/VehicleInspection/VehicleInspectionDashboard";
import Notifi from "../Screens/Drawer/Notifi";
import BottomTab from "../Screens/BottomTab/Bot";

// NOTE: Many not-yet-routed mobile screens (Add/Edit/View, Reports, Profile,
// CustomerSupport, AccessRights ...) either need uninstalled native deps
// (date-picker / image-picker / element-dropdown / maps) or carry pre-existing
// ESLint errors that fail the CRA build. They are mapped to the ComingSoon
// placeholder below so every production route name still resolves. Wire them
// to their real screens once those deps are installed and lint errors fixed.

// --- Newly built mobile screens that mirror the production site ---
import MyProfile from "../Screens/Profile/MyProfile";
import EditProfile from "../Screens/Profile/EditProfile";
import ChangePasswordProfile from "../Screens/Profile/ChangePasswordProfile";
import AddDeliveryPerson from "../Screens/Personnel/AddDeliveryPerson";
import * as P from "../Screens/Personnel";
import * as U from "../Screens/Generated/Users";
import * as M from "../Screens/Generated/MasterData";
import * as More from "../Screens/Generated/More";
import * as Miss from "../Screens/Generated/Missing";

// Placeholder for production routes whose mobile screen is not ready yet.
import ComingSoon from "../Screens/ComingSoon";

// Wraps each routed screen so the React-Navigation-style `navigation` prop
// (navigate/goBack) works under react-router instead of being undefined.
const Screen = ({ component: C }) => {
  const navigation = useAppNavigation();
  return <C navigation={navigation} route={{ params: navigation.params }} />;
};

const X = ComingSoon; // alias for not-yet-built screens

/**
 * Route table.
 * Path names mirror the production site (D:\Projects\demo.vehicletracking.qa).
 * Each path maps to the real mobile screen where one exists and compiles,
 * otherwise to the ComingSoon placeholder so the route still resolves.
 * Lower-case / legacy mobile paths are kept as aliases so existing in-app
 * navigation.navigate("...") calls keep working.
 */
const routeTable = [
  // ---- Auth ----
  ["/", Login],
  ["/Login", Login],
  // PDF: Login -> User Login (Username/View)
  ["/LoginApp/LoginApp/Username/View", Login],
  ["/Registration", Registration],
  ["/registration", Registration],
  // PDF: Login -> User Login (SaveAndProceedAllDetails/Save) - "Tell us about yourself"
  ["/LoginApp/LoginApp/SaveAndProceedAllDetails/Save", Registration],
  // PDF: Login -> User Login (ValidationResult/Save) - same "Tell us about yourself" screen
  ["/LoginApp/LoginApp/ValidationResult/Save", Registration],
  ["/ForgetPassword", ForgotPassword],
  ["/forgot-password", ForgotPassword],
  // PDF: Login -> User Login (ForgetPasswordScreen/Access)
  ["/LoginApp/LoginApp/ForgetPasswordScreen/Access", ForgotPassword],
  ["/DemoAccount", DemoAccount],
  ["/LoginWithOTP", More.LoginWithOTP],
  ["/RegistrationLocation", More.RegistrationLocation],
  ["/Animation", More.Animation],

  // ---- App shells (mobile-only) ----
  ["/DrawerScreen", DrawerScreen],
  // PDF: Dashboard module - DashboardMap (dashboard map is the Drawer "Dashboard" tab)
  ["/Dashboard/DashboardMap/DashboardDetails/View", DrawerScreen],
  ["/Dashboard/DashboardMap/DeviceDetails/View", DrawerScreen],
  ["/Dashboard/DashboardMap/Vehicle/View", DrawerScreen],
  ["/DashboardBottom", DashboardBottom],
  ["/Bot", BottomTab],
  ["/Notifi", Notifi],
  // PDF: Dashboard module - notifications / alerts list
  ["/Dashboard/DashboardMap/Alerts/View", Notifi],
  ["/Dashboard/DashboardMap/NotificationIcon/Visibility", Notifi],

  // ---- Master Data: Vehicles ----
  ["/Vehicle", Vehicles],
  // PDF: Master data Module -> Vehicle Submodule
  ["/MasterData/Vehicles/VehicleDetails/View", Vehicles],
  ["/VehicleDetails", M.VehicleDetails],
  ["/EditVehicle", M.EditVehicle],
  ["/AddVehicleGroup", M.AddVehicleGroup],
  ["/EditVehicleGroup", M.EditVehicleGroup],
  ["/AddVehicleCategory", M.AddVehicleCategory],
  ["/NewSyncRequest", M.NewSyncRequest],

  // ---- Holidays / Vacations ----
  ["/Holidays", Holidays],
  ["/AddHolidays", M.AddHolidays],
  ["/EditHolidays", M.EditHolidays],
  ["/Vacations", Vacation],
  ["/Vacation", Vacation],
  // PDF: Master data Module -> Vacations Submodule
  ["/MasterData/Vacations/VactionManegementDetails/Display", Vacation],
  ["/AddVacation", M.AddVacation],
  ["/EditVacation", M.EditVacation],

  // ---- Geofence / POI / Parking ----
  ["/GeofenceAreas", GeofenceArea],
  ["/GeofenceArea", GeofenceArea],
  ["/AddGeofenceArea", M.AddGeofenceArea],
  ["/EditGeofenceArea", M.EditGeofenceArea],
  ["/Overspeed", M.Overspeed],
  ["/PointOfIntrest", MainPointofInterest],
  ["/MainPointofInterest", MainPointofInterest],
  ["/AddPointOfInterest", M.AddPointOfInterest],
  ["/ParkingManagement", MainParkingManagement],
  ["/MainParkingManagement", MainParkingManagement],
  ["/ParkStation", ParkStation],
  ["/EditParkingSlot", M.EditParkingSlot],

  // ---- Users / Access ----
  ["/AllUsers", UsersAdministartion],
  ["/UsersAdministartion", UsersAdministartion],
  ["/CreateUser", U.CreateUser],
  ["/EditUser", U.EditUser],
  ["/AccessRight", U.AccessRight],
  ["/AcessRole", U.AcessRole],
  ["/UserRole", U.UserRole],

  // ---- Personnel ----
  ["/TransportManager", TransportManager],
  ["/ChangePassword", P.ChangeTransportPassword],
  ["/Drivers", Drivers],
  ["/EditDrivers", P.EditDriver],
  ["/ViewDrivers", P.ViewDriver],
  ["/AddDriver", P.AddDriver],
  ["/ChangeDriverPassword", P.ChangeDriverPassword],
  ["/DeliveryPerson", Delivery],
  ["/Delivery", Delivery],
  ["/AddDeliveryPerson", AddDeliveryPerson],
  ["/AddDeliveryperson", AddDeliveryPerson],
  ["/ChangeDelPass", P.ChangeDeliveryPassword],
  ["/FleetManager", FleetManager],
  ["/AddFleetManager", P.AddFleetManager],
  ["/EditFleetManager", P.EditFleetManager],
  ["/ViewFleetManager", P.ViewFleetManager],
  ["/ChangeFleetPass", P.ChangeFleetPass],
  ["/VehicleAssistants", VehicleAssistant],
  ["/VehicleAssistant", VehicleAssistant],

  // ---- Payment ----
  ["/Invoiced", PaymentInvoice],
  ["/PaymentInvoice", PaymentInvoice],
  ["/InvoiceDetails", More.InvoiceDetails],
  ["/Paid", PaidInvoice],
  ["/PaidInvoice", PaidInvoice],

  // ---- Dispatch / Orders ----
  ["/DispatchOrder", DispatchCustomer],
  ["/DispatchCustomer", DispatchCustomer],
  ["/DispatchDashboard", DispatchDashboard],
  ["/ViewOrders", Orders],
  ["/Orders", Orders],
  ["/Merchant", Merchant],
  ["/DispatchCustomerViewDetails", DispatchCustomerViewDetails],
  ["/AddDispatchCustomer", More.AddDispatchCustomer],
  ["/EditDispatchCustomer", More.EditDispatchCustomer],
  ["/ManualRouting", More.ManualRouting],
  ["/ViewOrder", More.ViewOrder],
  ["/DeliveryRequest", More.DeliveryRequest],
  ["/OrderConfDetails", More.OrderConfDetails],

  // ---- Dispatch Trips / Stops ----
  ["/AddDispatchTrip", More.AddDispatchTrip],
  ["/ViewDispatchTrip", More.ViewDispatchTrip],
  ["/EditDispatchTrip", More.EditDispatchTrip],
  ["/AddStop", More.AddStop],
  ["/EditStop", More.EditStop],
  ["/ViewStop", More.ViewStop],
  ["/AddStopnew", More.AddStopnew],
  ["/EditStopnew", More.EditStopnew],
  ["/ViewStopnew", More.ViewStopnew],

  // ---- Vehicle Expense / Spare / Accessory / Fine ----
  ["/VehicleExpenseOp", VehicleExpenseOp],
  ["/VehicleSpare", VehicleSpare],
  ["/VehicleAccessory", VehicleAccessory],
  ["/FleetMainTab", FleetMainTab],
  ["/AddVehicleFine", More.AddVehicleFine],
  ["/ViewVehicleFine", VehicleFine1],
  ["/VehicleFine1", VehicleFine1],

  // ---- Fuel ----
  ["/ViewFuelExpenses", FuelExpenses],
  ["/FuelExpenses", FuelExpenses],
  ["/FuelAlerts", More.FuelAlerts],

  // ---- Inspection ----
  ["/NewInspection", VehicleInspectionDashboard],
  ["/VehicleInspectionDashboard", VehicleInspectionDashboard],
  ["/InspectionPDF", More.InspectionPDF],

  // ---- User Dashboard ----
  ["/UserDashboard", UserInsightDaily],
  ["/UserInsightDaily", UserInsightDaily],
  ["/UserAlert", More.UserAlert],

  // ---- Profile / Support / Communication ----
  ["/MyProfile", MyProfile],
  ["/EditProfile", EditProfile],
  ["/ChangePasswordProfile", ChangePasswordProfile],
  ["/ChatBox", More.ChatBox],
  ["/NewTeamMessage", More.NewTeamMessage],
  ["/CustomerSupport", More.CustomerSupport],
  ["/ReportIssue", More.ReportIssue],
  ["/ViewReport", More.ViewReport],
  ["/EmailSupport", More.EmailSupport],
  ["/ComposeEmail", More.ComposeEmail],
  ["/EditAudio", More.EditAudio],
  ["/Changelogo", More.Changelogo],

  // ---- Reports ----
  ["/Reports", More.Reports],
  ["/ScheduleReport", More.ScheduleReport],
  ["/ReportView", More.ReportView],
  ["/Temprature", More.Temprature],

  // ---- MarketPlace / Auction ----
  ["/OnlineAuction", More.OnlineAuction],
  ["/BidAuctionDetails", More.BidAuctionDetails],
  ["/AuctionAddVehicle", More.AuctionAddVehicle],
  ["/AuctionOfferDetails", More.AuctionOfferDetails],
  ["/AuctionReferenceDetails", More.AuctionReferenceDetails],
  ["/LuxuryCars", More.LuxuryCars],

  // ---- Settings / Misc ----
  ["/LogoUpdate", More.LogoUpdate],
  ["/LogChanges", More.LogChanges],
  ["/LockScreen", More.LockScreen],
  ["/Privacypolicy", More.Privacypolicy],
  ["/AddPushNotification", More.AddPushNotification],

  // ---- Personnel (built) ----
  ["/AddTransportManager", P.AddTransportManager],
  ["/EditTransportManager", P.EditTransportManager],
  ["/ViewTransportManager", P.ViewTransportManager],
  ["/AddVehicleAssistants", P.AddVehicleAssistant],
  ["/EditVehicleAssistant", P.EditVehicleAssistant],
  ["/ViewVehicleAssistant", P.ViewVehicleAssistant],
  ["/ChangeVehiclePass", P.ChangeVehicleAssistantPassword],
  ["/EditDeliveryPerson", P.EditDeliveryPerson],
  ["/ViewDeliveryPerson", P.ViewDeliveryPerson],
  ["/ChangePassDelivery", P.ChangeDeliveryPassword],

  // ---- Full-parity screens (built) ----
  ["/AddDispatchTripnew", Miss.AddDispatchTripnew],
  ["/ViewDispatchTripnew", Miss.ViewDispatchTripnew],
  ["/EditVehicleAssistants", Miss.EditVehicleAssistants],
  ["/ViewVehicleAssistants", Miss.ViewVehicleAssistants],
  ["/EditPointOfInterest", Miss.EditPointOfInterest],
  ["/ParkingManagementone", Miss.ParkingManagementone],
  ["/ViewVehicleAccesory", Miss.ViewVehicleAccesory],
  ["/ViewVehicleAccident", Miss.ViewVehicleAccident],
  ["/ViewVehicleMaintenance", Miss.ViewVehicleMaintenance],
  ["/ViewVehicleSpareParts", Miss.ViewVehicleSpareParts],
  ["/NewVehicleInspection", Miss.NewVehicleInspection],
  ["/ViewInspectionDetails", Miss.ViewInspectionDetails],
  ["/PaidPaymentInvoice", Miss.PaidPaymentInvoice],
  ["/PaidPaymentReceipt", Miss.PaidPaymentReceipt],
  ["/FuelManagementDashbord", Miss.FuelManagementDashbord],
  ["/FuelManagementDetails", Miss.FuelManagementDetails],
  ["/Driverbehavioureports", Miss.Driverbehavioureports],
  ["/Immobiliserreports", Miss.Immobiliserreports],
  ["/GenerateCustomReport", Miss.GenerateCustomReport],
  ["/NotificationDetails", Miss.NotificationDetails],
  ["/UpdateCustomerLogo", Miss.UpdateCustomerLogo],
  ["/ConfigurationChecker", Miss.ConfigurationChecker],
  ["/DeliveryDispatchManagement", Miss.DeliveryDispatchManagement],
  ["/DirectOrderMarketPlace", Miss.DirectOrderMarketPlace],
  ["/DirectOrderAddVehicle", Miss.DirectOrderAddVehicle],
  ["/DirectOrderConfirmation", Miss.DirectOrderConfirmation],
  ["/DirectOrderOfferLoad", Miss.DirectOrderOfferLoad],
  ["/DirectOrderReferenceDetails", Miss.DirectOrderReferenceDetails],
  ["/DirectOrderVehicleDetails", Miss.DirectOrderVehicleDetails],
  ["/OfferDriverMarketPlace", Miss.OfferDriverMarketPlace],
  ["/OfferVehicleMarketPlace", Miss.OfferVehicleMarketPlace],
  ["/OnlineAuctionMarketPlace", Miss.OnlineAuctionMarketPlace],
  ["/OnlineAuctionVehicleDetails", Miss.OnlineAuctionVehicleDetails],
  ["/ReportDistributionContactsDetails", Miss.ReportDistributionContacts_Details],

  // =====================================================================
  // PDF: "Vt Mobile Screen View List" (Part 2) - production access-key
  // style routes. Each maps to the same mobile screen its screenshot URL
  // points to. Old flat paths above are kept as aliases.
  // =====================================================================

  // ---- Master Data: Point Of Interest (URL /MainPointofInterest) ----
  ["/MasterData/PointOfInterest/LocationMap/Search", MainPointofInterest],

  // ---- Master Data: Holiday (URL /Holidays) ----
  ["/MasterData/Holidays/SearchHoliday/Search", Holidays],

  // ---- Master Data: GeofenceAreas (URL /GeofenceArea) ----
  ["/MasterData/GeofenceAreas/BackendProcessingTime/Display", GeofenceArea],

  // ---- User: Administration (URL /UsersAdministartion) ----
  ["/Users/Administrator/Action/View", UsersAdministartion],

  // ---- User: Delivery Person (URL /Delivery) ----
  ["/Users/DeliveryPerson/InActiveDeliveryPersonTab/View", Delivery],
  ["/Users/DeliveryPerson/DeliveryPersonBlock/Block", Delivery],

  // ---- User: Fleet Manager (URL /FleetManager) ----
  ["/Users/FleetManager/ActiveFleetManagerTab/View", FleetManager],
  ["/Users/FleetManager/FleetManagerBlock/Block", FleetManager],

  // ---- User: Transport Manager (URL /TransportManager) ----
  ["/Users/TransportManager/ActiveTransportManagerTab/View", TransportManager],
  ["/Users/TransportManager/InActiveTransportManagerTab/View", TransportManager],
  ["/Users/TransportManager/TransportManagerIntroduction/View", TransportManager],
  ["/Users/TransportManager/TransportManagerPage/View", TransportManager],

  // ---- User: Vehicle Assistants (URL /VehicleAssistant) ----
  ["/Users/VehicleAssistants/ActiveVehicleAssistantsTab/View", VehicleAssistant],
  ["/Users/VehicleAssistants/VehicleAssistantsDetails/View", VehicleAssistant],
  ["/Users/VehicleAssistants/VehicleAssistantsBlock/Block", VehicleAssistant],

  // ---- Dispatch: Dispatch Customer (URL /DispatchCustomer) ----
  ["/DispatchManagement/DispatchCustomer/DispatchCustomerInformation/View", DispatchCustomer],
  ["/DispatchManagement/DispatchCustomer/RemoveCustomerDetails/Delete", DispatchCustomer],

  // ---- Dispatch: Dispatch Dashboard (URL /DispatchDashboard) ----
  ["/DispatchManagement/DispatchDashboard/DispatchAnalyze/View", DispatchDashboard],
  ["/DispatchManagement/DispatchDashboard/OrdersStatus/View", DispatchDashboard],
  ["/DispatchManagement/DispatchDashboard/CustomerSpecificDispatch/View", DispatchDashboard],

  // ---- Dispatch: Orders (URL /Orders) ----
  ["/DispatchManagement/Orders/OrderPage/View", Orders],

  // ---- Dispatch: Merchant (URL /Merchant) ----
  ["/DispatchManagement/Merchant/MerchantDetails/View", Merchant],
  ["/DispatchManagement/Merchant/DispatchHistory/View", Merchant],
  ["/DispatchManagement/Merchant/MerchantRemove/Delete", Merchant],

  // ---- Vehicle Expense: Vehicle Accident (URL /VehicleExpenseOp) ----
  ["/VehicleExpenses/VehicleAccident/VehicleAccidentAllData/View", VehicleExpenseOp],
  ["/VehicleExpenses/VehicleAccident/VehicleAccidentRemove/Delete", VehicleExpenseOp],

  // ---- Vehicle Expense: Vehicle Accessory (URL /VehicleAccessory) ----
  ["/VehicleExpenses/VehicleAccessory/ViewVehicleAccessory/Display", VehicleAccessory],
  ["/VehicleExpenses/VehicleAccessory/VehicleAccessoryDetails/View", VehicleAccessory],
  ["/VehicleExpenses/VehicleAccessory/RemoveVehicleAccessory/Delete", VehicleAccessory],

  // ---- Vehicle Expense: Vehicle Spare Parts (URL /VehicleSpare) ----
  ["/VehicleExpenses/VehicleSpareParts/SpareParts/Display", VehicleSpare],
  ["/VehicleExpenses/VehicleSpareParts/VehicleSparePartDetails/View", VehicleSpare],
  ["/VehicleExpenses/VehicleSpareParts/RemoveSpareParts/Delete", VehicleSpare],

  // ---- Vehicle Expense: Vehicle Fine (URL /VehicleFine1) ----
  ["/VehicleExpenses/VehicleFine/VehicleFineDetails/View", VehicleFine1],
  ["/VehicleExpenses/VehicleFine/VehicleFineView/Select", VehicleFine1],
  ["/VehicleExpenses/VehicleFine/RemoveViewFine/Delete", VehicleFine1],

  // ---- Vehicle Expense: Vehicle Fuel Expenses (URL /FuelExpenses) ----
  ["/VehicleExpenses/VehicleFuelExpense/VehicleFuelExpenseAll/Select", FuelExpenses],
  ["/VehicleExpenses/VehicleFuelExpense/ViewFuelExpensesDetails/ViewDetails", FuelExpenses],
  ["/VehicleExpenses/VehicleFuelExpense/DeleteFuelExpense/Delete", FuelExpenses],

  // ---- Vehicle Expense: Vehicle Maintenance (URL /FleetMainTab) ----
  ["/VehicleExpenses/VehicleMaintenance/VehicleMaintenanceGeneralInfo/ViewDetails", FleetMainTab],
  ["/VehicleExpenses/VehicleMaintenance/DuesVehicleMaintenance/View", FleetMainTab],
  ["/VehicleExpenses/VehicleMaintenance/HistoryVehicleMaintenance/View", FleetMainTab],
  ["/VehicleExpenses/VehicleMaintenance/VehicleMaintenanceUpcoming/View", FleetMainTab],
];

function AppRoutes() {
  return (
    <Router>
      <Routes>
        {routeTable.map(([path, Component]) => (
          <Route
            key={path}
            path={path}
            element={<Screen component={Component} />}
          />
        ))}
        {/* Unknown paths fall back to a friendly placeholder instead of a blank page */}
        <Route path="*" element={<Screen component={ComingSoon} />} />
      </Routes>
    </Router>
  );
}

export default AppRoutes;

// route table aligned to production site
